<template>
  <path
    d="M9.21 11.0002H11V20.0002C11 20.5502 11.45 21.0002 12 21.0002C12.55 21.0002 13 20.5502 13 20.0002V11.0002H14.79C15.24 11.0002 15.46 10.4602 15.14 10.1502L12.35 7.36024C12.15 7.16024 11.84 7.16024 11.64 7.36024L8.85 10.1502C8.54 10.4602 8.76 11.0002 9.21 11.0002ZM4 4.00024C4 4.55024 4.45 5.00024 5 5.00024H19C19.55 5.00024 20 4.55024 20 4.00024C20 3.45024 19.55 3.00024 19 3.00024H5C4.45 3.00024 4 3.45024 4 4.00024Z"
  />
</template>
